var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedinComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66837 7.31055H13.2136V7.96055H6.66837V7.31055ZM6.66837 9.91055H11.2501V9.26055H6.66837V9.91055ZM17.1408 8.61055C17.1505 9.32225 16.9865 10.0257 16.6628 10.6607C16.3391 11.2958 15.8653 11.8435 15.2819 12.257L9.94101 15.7605V13.1605H7.3229C6.10776 13.1605 4.94239 12.6812 4.08316 11.8279C3.22392 10.9746 2.74121 9.81728 2.74121 8.61055C2.74121 7.40381 3.22392 6.2465 4.08316 5.39321C4.94239 4.53992 6.10776 4.06055 7.3229 4.06055H12.5591C13.7743 4.06055 14.9396 4.53992 15.7989 5.39321C16.6581 6.2465 17.1408 7.40381 17.1408 8.61055ZM15.8318 8.61055C15.8318 7.74859 15.487 6.92194 14.8732 6.31245C14.2595 5.70296 13.4271 5.36055 12.5591 5.36055H7.3229C6.45494 5.36055 5.62254 5.70296 5.0088 6.31245C4.39506 6.92194 4.05026 7.74859 4.05026 8.61055C4.05026 9.4725 4.39506 10.2992 5.0088 10.9086C5.62254 11.5181 6.45494 11.8605 7.3229 11.8605H11.2501V13.3425L14.5227 11.2105C14.9374 10.9156 15.2734 10.5247 15.5015 10.0716C15.7296 9.61849 15.843 9.11698 15.8318 8.61055Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinComment);
export default __webpack_public_path__ + "static/media/linkedinComment.760b15f0.svg";
export { ForwardRef as ReactComponent };